<template>
  <nav class="nav-banner">
    <div class="nav clearfix">
      <img src="~@/assets/images/logo.png" style="width: 110px; float: left;margin-top: 3px;cursor: pointer;"
        @click="$router.push('/')" alt=""/>
      <ul class="nav-fl">
        <li :class="{ active: headName == 'product' }">
          <a @mouseover="hovernav = true" @mouseout="hovernav = false" href="javascript:">{{ $t('hot-header.c01') }}</a>
        </li>
        <li :class="{ active: headName == 'docs' }">
          <router-link tag="a" to="/docs">{{$t('hot-header.a01') }}</router-link>
        </li>
        <li @mouseover="hovercus = true" @mouseout="hovercus = false" :class="{ active: headName == 'customer' }">
          <router-link tag="a" to="/customer">{{$t('hot-header.x08') }}</router-link>
        </li>
        <li :class="{ active: headName == 'download' }">
          <router-link tag="a" to="/download">{{$t('hot-header.m21') }}</router-link>
        </li>
        <li :class="{ active: headName == 'aboutUs' }">
          <a href="javascript:" @mouseover="hoverUs = true" @mouseout="hoverUs = false">{{ $t('hot-header.m01') }}</a>
        </li>
      </ul>

      <ul class="nav-fr">
        <li class="cln">
          <span @click="setLanguage('en')">En</span> | <span @click="setLanguage('zh')">中文</span>
        </li>
        <template v-if="isLogin">
          <li class="nav-w-80"><a href="javascript:" @click="sign('login')">{{ $t('hot-header.m02') }}</a></li>
          <li class="nav-w-80"><a href="javascript:" @click="sign('register')">{{$t('hot-header.m03')}}</a></li>
        </template>
        <template v-else>
          <li v-if="userType == 1">
            <router-link tag="a" to="/authmanage">{{ $t('hot-header.pc01') }}</router-link>
          </li>
          <li>
            <router-link tag="a" to="/user-info"> {{account}}</router-link>
            <!--不使用简单的用户头像图片-->
            <!--<router-link to="/user-info" tag="a" :title="account">-->
            <!--  <img style="margin-top:16px;width: 20px" src="~@/assets/product/b-nav-4.png" alt=""/></router-link>-->
          </li>
          <li class="nav-w-80"><a href="javascript:" @click="logout">{{ $t('hot-header.m19') }}</a></li>
        </template>
      </ul>
    </div>

    <transition name="fade">
      <div class="hover-nav" v-show="hovernav" @mouseover="hovernav = true" @mouseout="hovernav = false">
        <div class="wrapper pc">
          <div>
            <router-link tag="a" to="/server">{{ $t('hotdb-server') }}</router-link>
          </div>
          <div>
            <router-link tag="a" to="/cloud">{{ $t('hotdb-cloud') }}</router-link>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="hover-nav" v-show="hovercus" @mouseover="hovercus = true" @mouseout="hovercus = false">
        <div class="wrapper cc">
          <div>
            <router-link tag="a" to="/customer-case">{{$t('hot-header.d02') }}</router-link>
          </div>
          <div>
            <router-link tag="a" to="/customer">{{$t('hot-header.d03') }}</router-link>
          </div>
          <div>
            <router-link tag="a" to="/trade">{{$t('hot-header.d04') }}</router-link>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="hover-nav" v-show="hoverUs" @mouseover="hoverUs = true" @mouseout="hoverUs = false">
        <div class="wrapper au">
          <div>
            <router-link tag="a" to="/aboutUs">{{$t('hot-header.m04') }}</router-link>
          </div>
          <div v-if="this.$getLanguage()=='zh'">
            <router-link tag="a" to="/join-us">{{$t('hot-header.m05') }}</router-link>
          </div>
          <div v-if="this.$getLanguage()=='zh'">
            <router-link tag="a" to="/news">{{$t('hot-header.m24') }}</router-link>
          </div>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: "HotHeader",
  data() {
    return {
      isLogin: true,
      hovernav: false,
      hoverUs: false,
      hovercus: false,
      account: "",
      language: false,
      userType: 0
    }
  },
  props: {
    headName: {
      type: String,
      default: "product",
    },
  },
  created() {
    this.userType = this.$utils.getStorage("userType")
    this.account = this.$utils.getStorage("account")
    this.isOprtion()
  },
  methods: {
    setLanguage(lang) {
      this.$setLanguage(lang)
    },
    sign(url) {
      if(url == "login") {
        this.$utils.setStorage("beforeLoginUrl", this.$route.path)
      } else {
        this.$utils.setStorage("sign", "false")
      }
      this.$router.push("/sign")
    },
    async logout() {
      // 清掉所有信息 返回到首页
      let res = await this.$services.logout()
      if(res.code == 0) {
        this.$utils.clearStorage()
        this.$router.push("/index")
      } else {
        this.$alert(res.message)
      }
    },
    isOprtion() {
      this.isLogin = !this.$utils.getStorage("isLogin")
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-banner {
  border-bottom: 1px solid #686d85;
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, .15);
  }

  .hover-nav {
    position: absolute;
    left: 0px;
    top: 60px;
    right: 0;
    padding-top: 24px;
    min-height: 130px;
    background: rgba(9, 16, 75, 0.8);
    border-radius: 5px;
    z-index: 20;

    a {
      line-height: 32px;
    }

    z-index: 101;

    $pc-offset: 165px; //110 + 30 + 25
    $cc-offset: 377px; //110 + 30 + 106 * 2 + 25
    $au-offset: 589px; //110 + 30 + 106 * 4 + 25

    .pc {
      div {
        padding-left: $pc-offset;
      }
    }
    .cc {
      div {
        padding-left: $cc-offset;
      }
    }
    .au {
      div {
        margin-left: $au-offset;
      }
    }
  }
}

.en {
  .nav-banner {
    .hover-nav {
      $pc-offset: 165px; //110 + 30 + 25
      $cc-offset: 485px; //110 + 30 + 146 + 174 + 25
      $au-offset: 798px; //110 + 30 + 146 + 174 + 148 + 165 + 25

      .pc {
        div {
          padding-left: $pc-offset;
        }
      }
      .cc {
        div {
          padding-left: $cc-offset;
        }
      }
      .au {
        div {
          margin-left: $au-offset;
        }
      }
    }
  }
}

.nav {
  max-width: 1250px;
  margin: 0 auto;
  position: relative;

  li {
    float: left;
  }

  li a {
    display: block;
    padding: 0 10px;
    line-height: 58px;
    height: 58px;
  }

  li.active a {
    border-bottom: 2px solid #41eaf1;
  }
}

.nav-fl {
  position: relative;
  float: left;
  margin-left: 30px;

  li {
    padding: 0 15px;
  }
}

.nav-fr {
  float: right;
}

.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.wrapper{
  max-width: 1250px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HotHeader.vue